"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Lesionnel = void 0;
const utils_1 = require("./utils");
const data_1 = require("./data");
const lesionnelAvantTetev2_1 = require("./lesionnel/lesionnelAvantTetev2");
const lesionnelAvantV2_1 = require("./lesionnel/lesionnelAvantV2");
const lesionnelArriereV2_1 = require("./lesionnel/lesionnelArriereV2");
const lesionnelMainDroitV2_1 = require("./lesionnel/lesionnelMainDroitV2");
const lesionnelMainGaucheV2_1 = require("./lesionnel/lesionnelMainGaucheV2");
const lesionnelPiedGaucheV2_1 = require("./lesionnel/lesionnelPiedGaucheV2");
const lesionnelPiedDroitV2_1 = require("./lesionnel/lesionnelPiedDroitV2");
class Lesionnel {
    constructor(bilan) {
        this.age = typeof bilan.victime.age === 'string' ? parseFloat(bilan.victime.age) : bilan.victime.age;
        this.ageUnit = bilan.victime.age_unit;
        this.sex = bilan.victime.sexe;
        this.civility = bilan.victime.civilite;
        this.typeAge = 'adulte';
        switch (this.ageUnit) {
            case 1: // Jours
                if (this.age <= 1095) {
                    this.typeAge = 'nourisson';
                }
                else if (this.age >= 1096 && this.age <= 4380) {
                    this.typeAge = 'enfant';
                }
                break;
            case 2: // Mois
                if (this.age <= 36) {
                    this.typeAge = 'nourisson';
                }
                else if (this.age >= 37 && this.age <= 144) {
                    this.typeAge = 'enfant';
                }
                break;
            default: // Ans ou null
                if (bilan.victime.age === '')
                    break;
                if (this.age <= 3) {
                    this.typeAge = 'nourisson';
                }
                else if (this.age >= 4 && this.age <= 12) {
                    this.typeAge = 'enfant';
                }
                break;
        }
        let sex = 'nr';
        switch (this.sex) {
            case 0:
            case '0':
                sex = 'nr';
                break;
            case 1:
            case '1':
                sex = 'homme';
                break;
            case 2:
            case '2':
                sex = 'femme';
                break;
            case 3:
            case '3':
                sex = 'ind';
                break;
        }
        let civilite = 'ind';
        switch (this.civility) {
            case 1:
                civilite = 'monsieur';
                break;
            case 2:
                civilite = 'madame';
                break;
        }
        if (civilite === 'madame' || sex === 'femme') {
            this.typeSex = 'femme';
        }
        else {
            this.typeSex = 'homme';
        }
        this.descArriere = bilan.lesionnel.desc_arriere;
        this.descAvant = bilan.lesionnel.desc_avant;
        this.allGradients = [];
        this.lesionnelAvant = bilan.lesionnel_avant;
        this.lesionnelAvantV2 = this.extractBodyFrontFromLesionnel(bilan.lesionnel_avant_v2) || null;
        this.lesionnelAvantTeteV2 = this.extractHeadFromLesionnel(bilan.lesionnel_avant_v2) || null;
        this.lesionnelArriere = bilan.lesionnel_arriere;
        this.lesionnelArriereV2 = this.extractBodyBackFromLesionnel(bilan.lesionnel_arriere_v2) || null;
        this.lesionnelMainGaucheV2 =
            this.extractHandLeftFromLesionnel(bilan.lesionnel_avant_v2, bilan.lesionnel_arriere_v2) || null;
        this.lesionnelMainDroitV2 =
            this.extractHandRightFromLesionnel(bilan.lesionnel_avant_v2, bilan.lesionnel_arriere_v2) || null;
        this.lesionnelPiedGaucheV2 =
            this.extractFootLeftFromLesionnel(bilan.lesionnel_avant_v2, bilan.lesionnel_arriere_v2) || null;
        this.lesionnelPiedDroitV2 =
            this.extractFootRightFromLesionnel(bilan.lesionnel_avant_v2, bilan.lesionnel_arriere_v2) || null;
        this.hasDataDescAvant = this.descAvant !== '';
        this.hasDataDescArriere = this.descArriere !== '';
        this.hasDataLesionnelAvant = (0, utils_1.hasNumberData)(this.lesionnelAvant);
        this.hasDataLesionnelArriere = (0, utils_1.hasNumberData)(this.lesionnelArriere);
        this.hasDataLesionnelAvantV2 = (0, utils_1.hasNumberData)(this.lesionnelAvantV2);
        this.hasDataLesionnelArriereV2 = (0, utils_1.hasNumberData)(this.lesionnelArriereV2);
        this.hasDataLesionnelAvantTeteV2 = (0, utils_1.hasNumberData)(this.lesionnelAvantTeteV2);
        this.hasDataLesionnelMainGaucheV2 = (0, utils_1.hasNumberData)(this.lesionnelMainGaucheV2);
        this.hasDataLesionnelMainDroitV2 = (0, utils_1.hasNumberData)(this.lesionnelMainDroitV2);
        this.hasDataLesionnelPiedGaucheV2 = (0, utils_1.hasNumberData)(this.lesionnelPiedGaucheV2);
        this.hasDataLesionnelPiedDroitV2 = (0, utils_1.hasNumberData)(this.lesionnelPiedDroitV2);
        this.hasData = [
            this.hasDataDescAvant,
            this.hasDataDescArriere,
            this.hasDataLesionnelAvant,
            this.hasDataLesionnelAvantV2,
            this.hasDataLesionnelArriere,
            this.hasDataLesionnelArriereV2,
            this.hasDataLesionnelAvantTeteV2,
            this.hasDataLesionnelMainGaucheV2,
            this.hasDataLesionnelMainDroitV2,
            this.hasDataLesionnelPiedGaucheV2,
            this.hasDataLesionnelPiedDroitV2,
        ].some(elem => elem);
    }
    extractBodyFrontFromLesionnel(front) {
        if (front === undefined)
            return null;
        const temp = new lesionnelAvantV2_1.LesionnelAvantV2Impl();
        data_1.TEXTIFY_FRONT.map(item => {
            temp[item[0]] = this.parseLesionnel(front[item[0]]);
        });
        return temp;
    }
    extractBodyBackFromLesionnel(back) {
        if (back === undefined)
            return null;
        const temp = new lesionnelArriereV2_1.LesionnelArriereV2Impl();
        data_1.TEXTIFY_BACK.map(item => {
            temp[item[0]] = this.parseLesionnel(back[item[0]]);
        });
        return temp;
    }
    extractHeadFromLesionnel(front) {
        if (front === undefined)
            return null;
        const temp = new lesionnelAvantTetev2_1.LesionnelAvantTeteV2Impl();
        data_1.TEXTIFY_FRONT_HEAD.map(item => {
            temp[item[0]] = this.parseLesionnel(front[item[0]]);
        });
        return temp;
    }
    extractHandRightFromLesionnel(front, back) {
        if (front === undefined || back === undefined)
            return null;
        const temp = new lesionnelMainDroitV2_1.LesionnelMainDroitV2Impl();
        data_1.TEXTIFY_FRONT_HAND_RIGHT.map(item => {
            temp[item[0]] = this.parseLesionnel(front[item[0]]);
        });
        data_1.TEXTIFY_BACK_HAND_RIGHT.map(item => {
            temp[item[0]] = this.parseLesionnel(back[item[0]]);
        });
        return temp;
    }
    extractHandLeftFromLesionnel(front, back) {
        if (front === undefined || back === undefined)
            return null;
        const temp = new lesionnelMainGaucheV2_1.LesionnelMainGaucheV2Impl();
        data_1.TEXTIFY_FRONT_HAND_LEFT.map(item => {
            temp[item[0]] = this.parseLesionnel(front[item[0]]);
        });
        data_1.TEXTIFY_BACK_HAND_LEFT.map(item => {
            temp[item[0]] = this.parseLesionnel(back[item[0]]);
        });
        return temp;
    }
    extractFootRightFromLesionnel(front, back) {
        if (front === undefined || back === undefined)
            return null;
        const temp = new lesionnelPiedDroitV2_1.LesionnelPiedDroitV2Impl();
        data_1.TEXTIFY_FRONT_FOOT_RIGHT.map(item => {
            temp[item[0]] = this.parseLesionnel(front[item[0]]);
        });
        data_1.TEXTIFY_BACK_FOOT_RIGHT.map(item => {
            temp[item[0]] = this.parseLesionnel(back[item[0]]);
        });
        return temp;
    }
    extractFootLeftFromLesionnel(front, back) {
        if (front === undefined || back === undefined)
            return null;
        const temp = new lesionnelPiedGaucheV2_1.LesionnelPiedGaucheV2Impl();
        data_1.TEXTIFY_FRONT_FOOT_LEFT.map(item => {
            temp[item[0]] = this.parseLesionnel(front[item[0]]);
        });
        data_1.TEXTIFY_BACK_FOOT_LEFT.map(item => {
            temp[item[0]] = this.parseLesionnel(back[item[0]]);
        });
        return temp;
    }
    parseLesionnel(value) {
        const parse = {
            colors: [],
            textColors: [],
            colorFiller: '',
            value,
        };
        if (value !== undefined && value > 0) {
            data_1.MANNEQUIN_COLORS.forEach((color, idx) => {
                if ((0, utils_1.getBit)(value, idx) !== 0) {
                    parse.colors.push(color[1]);
                    parse.textColors.push(color[0]);
                }
            });
            parse.colorFiller = `gradient-${parse.colors.length}-${parse.textColors.join('-')}`;
            this.checkAllGradients(parse);
        }
        return parse;
    }
    checkAllGradients(parseLesionnel) {
        let hasValue = false;
        if (this.allGradients.some(e => parseLesionnel.colorFiller === e[2]))
            hasValue = true;
        if (!hasValue)
            this.allGradients.push([[...parseLesionnel.textColors], [...parseLesionnel.colors], parseLesionnel.colorFiller]);
    }
}
exports.Lesionnel = Lesionnel;
